import { Fragment} from "react";
import React from "react";
import {
  Transition,
} from "@headlessui/react";
import {Navigate, useParams } from "react-router-dom";
import {
  XIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
} from "@heroicons/react/solid";
import axios from "axios";



class InvoicerecordpaymentEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showmsg: false,
      invoiceNumber: "",
      invoice_date: "",
      balance_due: 0,
      error_list: [],
      invoiceDetails: [],
      paymentmode: [],
      invoice_id: "",
      amount_received: "",
      payment_date: "",
      mode_of_payment_id: "",
      notes: "",

      deletealartmsg: false,
      overLay: "",
      loader: "",
      message: "",
      icon: "",
      loader_status: false,
      try_again_status: false,
      main_content_status: false,
    };
    //  this.handleInput = this.handleInput.bind(this);
    //this.addLine = this.addLine.bind(this);
  }

  setLoaderFunction = () => {

    this.setState({
      loader_status: true,
      try_again_status: false,
      main_content_status: false,
    });
  };
  closeLoaderFuncion = () => {
    this.setState({
      loader_status: false,
      try_again_status: false,
      main_content_status: true,
    });
  };

  enableTryAgain = () => {

    this.setState({
      loader_status: false,
      try_again_status: true,
      main_content_status: false,
    });
  };

  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    this.setState({ sidebarOpen: true });
  };


  async componentDidMount() {

    this.getDataForPagination();

  }


  async getDataForPagination() {
    try {
      this.setLoaderFunction()
      const token = localStorage.getItem("token");
      const { id } = this.props.params;
      const [
        { data: edit },
        { data: urlforcreate },
      ] = await Promise.all([
        axios.get("api/customer/payment/received/edit/" + id, { headers: { authorization: `Bearer ${token}`, Accept: "application/json" } }),
        axios.get("api/customer/payment/urlforcreate", { headers: { authorization: `Bearer ${token}`, Accept: "application/json" } }),
      ]);


      this.setState({
      });
      this.setState({
        invoiceDetails: edit.customer_payment_received,
        invoice_id: edit.customer_payment_received.invoice.id,
        invoice_idcrypt: edit.customer_payment_received.invoice.id_crypt,
        invoiceNumber: edit.customer_payment_received.invoice.invoice_number,
        invoice_date: edit.customer_payment_received.invoice.invoice_date,
        amount_received: edit.customer_payment_received.amount_received,
        payment_date: edit.customer_payment_received.payment_date,
        mode_of_payment_id: edit.customer_payment_received.mode_of_payment_id,
        notes: edit.customer_payment_received.notes,
      });
      this.setState({ paymentmode: urlforcreate.mode_of_payment });
      this.closeLoaderFuncion();

    } catch (error) {
      this.enableTryAgain();
    }
  }

  tryAgain = () => {
        this.getDataForPagination();
  }


  handleInputpaymentdetails = async (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  delete = async (e) => {
    this.setState({ deletealartmsg: true });
    this.setState({ cryptKey: e });
  };

  haldleDelete = async (e) => {
    if (this.state.deletealartmsg) {
      const token = localStorage.getItem("token");
      let id = this.state.cryptKey;
      //const id=this.setState({cryptKey:e});
      const resDelete = axios
        .get("api/customer/payment/received/delete/" + id, {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((resDelete) => {
          if (resDelete.data.success) {
            this.setState({ deleteRedirect: true });
            this.setState({ deletealartmsg: false });
          }
        });
    }
  };

  saveItem = async (e) => {
    this.setLoaderFunction();
    e.preventDefault();
    const { id } = this.props.params;

    var token = localStorage.getItem("token");
    const headers = {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
    };

    const res = await axios.post(
      "api/customer/payment/received/update/" + id,
      this.state,
      { headers }
    );

    if (res.data.success) {
      this.state.message = "Successfully Saved";
      this.setState({ message: this.state.message });
      this.setState({ showmsg: true });

      setTimeout(
        function () {
          //Start the timer
          this.closeLoaderFuncion();
          this.setState({ redirect: true }); //After 1 second, set render to true
        }.bind(this),
        1000
      );
    } else {
      this.closeLoaderFuncion();
      if (res.data.data != undefined) {
        this.state.error_list = res.data.data;
        this.setState({ error_list: this.state.error_list });
      } else {
        this.state.error_list = null;
        this.setState({ error_list: this.state.error_list });
        this.state.message = res.data.message;
        this.setState({ message: this.state.message });
        this.setState({ showmsg: true });

        setTimeout(
          function () {
            this.setState({ message: "" });
            this.setState({ showmsg: false });
          }.bind(this),
          1000
        );
      }
    }
  };

  //Logout function

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    if (res.data.success) {
      localStorage.removeItem("token");
      this.setState({ logoutRedirect: true });
    }
  };

  //Logout function

  render() {
    const cancelButtonRef = null;

    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.redirect) {
      return <Navigate to={"/admin/invoiceview/" + this.state.invoice_idcrypt} />;
    }



    return (
      <>
        <div>
          <div className={this.state.overLay} aria-hidden="true" />


          {/*loader_status------------------------------------------------------------------------*/}
          {this.state.loader_status && (
            <div className="h-screen flex items-center justify-center bg-white bg-opacity-50 z-50">
              <div className="bg-white p-4 rounded-md">
                <div className="flex items-center justify-center">
                  <div
                    className="animate-spin rounded-full border-4 border-l-blue-500 border-r-blue-500 border-t-blue-500 border-white-300 h-12 w-12"></div>
                </div>
                <p className="text-center mt-4">Loading...</p>
              </div>
            </div>
          )}
          {/*loader_status------------------------------------------------------------------------*/}

          {/*try_again_status-----------------------------------------------------------------------------*/}
          {this.state.try_again_status && (
            <div className="h-screen flex items-center justify-center bg-white ">
              <div className="flex flex-col items-center justify-center h-full">
                <p className="text-red-500">{this.state.error_customize}</p>
                <button
                  type="button"
                  onClick={this.tryAgain}
                  className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                  TryAgain
                </button>
              </div>
            </div>
          )}
          {/*try_again_status-----------------------------------------------------------------------------*/}





          {this.state.main_content_status && (

            <div className="flex flex-col flex-1">


              <main className="flex-1">
                <div className="py-6">
                  <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                    <h1 className="text-2xl font-semibold text-gray-900">
                      Record Payment
                    </h1>
                  </div>
                  <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                    {/* Replace with your content */}

                    <div className="hidden sm:block" aria-hidden="true">
                      <div className="py-5">
                        <div className="border-t border-gray-200" />
                      </div>
                    </div>
                    <div className={`mt-10 sm:mt-0 ${this.state.loader}`}>
                      <div className="md:grid md:gap-6">
                        <div className="mt-5 md:mt-0 md:col-span-2">
                          <form onSubmit={this.saveItem}>
                            <div className="shadow overflow-hidden sm:rounded-md">
                              <div className="px-4 py-5 bg-white sm:p-6">
                                <div className="grid grid-cols-6 gap-6">
                                  {/*start*/}



                                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label
                                      htmlFor="invoiceNumber"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Due Number
                                    </label>
                                    <input
                                      type="text"
                                      name="invoiceNumber"
                                      id="invoiceNumber"
                                      disabled
                                      value={this.state.invoiceNumber}
                                      readOnly
                                      onChange={this.handleInputpaymentdetails}
                                      autoComplete="invoiceNumber"
                                      className="mt-1 focus:ring-indigo-500 disabled:bg-slate-50 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                    />
                                  </div>

                                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label
                                      htmlFor="invoice_date"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Due created Date
                                    </label>
                                    <input
                                      type="Date"
                                      name="invoice_date"
                                      id="invoice_date"
                                      value={this.state.invoice_date}
                                      disabled
                                      onChange={this.handleInputpaymentdetails}
                                      autoComplete=""
                                      className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                    />
                                  </div>


                                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label
                                      htmlFor="amount_received"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Amount Received(INR)*
                                    </label>
                                    <input
                                      type="number"
                                      name="amount_received"
                                      id="amount_received"
                                      value={this.state.amount_received}
                                      onChange={this.handleInputpaymentdetails}
                                      autoComplete="amount_received"
                                      className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                    />
                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="amount_received-error"
                                    >
                                      {this.state.error_list?.amount_received}
                                    </p>
                                  </div>


                                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label
                                      htmlFor="payment_date"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Payment Date*
                                    </label>
                                    <input
                                      type="Date"
                                      name="payment_date"
                                      id="payment_date"
                                      value={this.state.payment_date}
                                      onChange={this.handleInputpaymentdetails}
                                      autoComplete="payment_date"
                                      className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                    />
                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="payment_date-error"
                                    >
                                      {this.state.error_list?.payment_date}
                                    </p>
                                  </div>
                                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label
                                      htmlFor="mode_of_payment_id"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Payment Mode
                                    </label>
                                    <select
                                      id="mode_of_payment_id"
                                      name="mode_of_payment_id"
                                      value={this.state.mode_of_payment_id}
                                      onChange={this.handleInputpaymentdetails}
                                      className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                    >
                                      <option value="0">------</option>
                                      {this.state.paymentmode.map((number,index) => (
                                        <option key={index} value={number.id}>
                                          {number.name}
                                        </option>
                                      ))}
                                    </select>
                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="email-error"
                                    >
                                      {this.state.error_list?.mode_of_payment_id}
                                    </p>
                                  </div>


                                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label
                                      htmlFor="notes"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Note
                                    </label>
                                    <div className="sm:col-span-3">
                                      <div className="mt-1">
                                        <textarea
                                          rows={2}
                                          name="notes"
                                          value={this.state.notes ||''}
                                          id="notes"
                                          onChange={
                                            this.handleInputpaymentdetails
                                          }
                                          className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                        />
                                      </div>
                                    </div>
                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="notes-error"
                                    >
                                      {this.state.error_list?.notes}
                                    </p>
                                  </div>
                                </div>
                              </div>

                              <div className="px-4 py-3 bg-gray-50 text-right sm:px-3">
                                <button
                                  type="submit"
                                  className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                >
                                  Record Payment
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>

                    {/* /End replace */}
                  </div>
                </div>
              </main>
            </div>
          )}
        </div>

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        {this.state.message}
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
        {/**/}

        {/**/}
      </>
    );
  }
}

export default (props) => (
  <InvoicerecordpaymentEdit {...props} params={useParams()} />
);
